export const LOAD_MAILS = 'LOAD_MAILS'
export const ADD_MAIL = 'ADD_MAIL'
export const DESTROY_MAIL = 'DESTROY_MAIL'
export const LOAD_USER_CONTACTS = 'LOAD_USER_CONTACTS'
export const LOAD_PRIORITIES = 'LOAD_PRIORITIES'
export const ADD_NEW_MAILS = 'ADD_NEW_MAILS'
export const LOAD_ACTIVE_SIGNATURE = 'LOAD_ACTIVE_SIGNATURE'
export const LOAD_SIGNATURES = 'LOAD_SIGNATURES'
export const LOAD_SCHEDULE_MAILS = 'LOAD_SCHEDULE_MAILS'
export const SET_UNSEEN_MAIL_COUNT = 'SET_UNSEEN_MAIL_COUNT'
export const SET_CURRENT_MAIL = 'SET_CURRENT_MAIL'
export const SET_CONFIG_IMAP = 'SET_CONFIG_IMAP'
export const MAKE_MAILS_AS_READ = 'MAKE_MAILS_AS_READ'
export const MAKE_MAILS_AS_UN_READ = 'MAKE_MAILS_AS_UN_READ'
export const MAKE_MAILS_AS_IMPORTANT = 'MAKE_MAILS_AS_IMPORTANT'
export const MAKE_MAILS_AS_NOT_IMPORTANT = 'MAKE_MAILS_AS_NOT_IMPORTANT'
export const RESET_CURRENT_MAIL = 'RESET_CURRENT_MAIL'